import { RulerSquareIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useGeckoAnalytics } from 'features/analytics'
import { useKestrel } from 'features/kestrelViewer'
import { useKestrelViewerContext } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import { ViewToggle } from 'features/kestrelViewer/ui/tools/ViewToggle'
import React, { FC, useEffect, useState } from 'react'

type Unit = 'Meters' | 'Feet' | 'Inches'

export const ToggleUnitsButton: FC = () => {
  const { sendCommand } = useKestrelViewerContext()
  const { trackButtonClicked } = useGeckoAnalytics()
  const { kestrelModel } = useKestrel()

  const defaultUnit = 'Meters'
  const [currentUnit, setCurrentUnit] = useState<Unit>(defaultUnit)

  const units: Unit[] = ['Meters', 'Feet', 'Inches']

  // Ensure the unit is set to the default unit when the component mounts
  useEffect(() => {
    sendCommand({
      command: 'changeMeasurementUnit',
      measurementUnit: currentUnit.toLowerCase(),
    })
    // Dispatch unit change event so other components can update
    window.dispatchEvent(new CustomEvent('unitChange', { detail: currentUnit }))
  }, [sendCommand, currentUnit])

  const handleClick = () => {
    const currentIndex = units.indexOf(currentUnit)
    const nextIndex = (currentIndex + 1) % units.length
    const nextUnit = units[nextIndex]

    setCurrentUnit(nextUnit)
    sendCommand({
      command: 'changeMeasurementUnit',
      measurementUnit: nextUnit.toLowerCase(),
    })
    trackButtonClicked({
      button_name: 'kestrel_change_measurement_unit',
      kestrel_model_id: kestrelModel?.data.kestrel_model_id,
    })
  }

  return (
    <TooltipWrapper
      side='top'
      offset={5}
      label={`Current Unit: ${currentUnit}`}>
      <ViewToggle onClick={handleClick}>
        <RulerSquareIcon style={{ color: 'white' }} width={22} height={22} />
      </ViewToggle>
    </TooltipWrapper>
  )
}
